import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment/moment'

import { EmptyList } from 'react-wot-bootstrap'

import { UNIT_TYPES } from 'constants'
import { BATTLES_UNAVAILABLE } from './translations'
import { getNextBattleMessage } from './helpers'

const NoBattlesMessage = props => {
    const { showDescription, playdays, playdayStart, playdayEnd, unitType } = props
    const currentHour = moment.utc().hour()

    let message = ''
    if (showDescription) {
        message = getNextBattleMessage(playdays, playdayStart, playdayEnd, unitType, currentHour)
    }

    return <EmptyList title={BATTLES_UNAVAILABLE} message={message} />
}

NoBattlesMessage.propTypes = {
    showDescription: PropTypes.bool,
    playdays: PropTypes.array,
    playdayStart: PropTypes.number,
    playdayEnd: PropTypes.number,
    unitType: PropTypes.oneOf(Object.values(UNIT_TYPES)),
}

export default NoBattlesMessage



// WEBPACK FOOTER //
// ./containers/Schedule/components/NoBattlesMessage/NoBattlesMessage.jsx